import React, { useRef, useState, useEffect } from 'react';
import { useQuery } from '@tanstack/react-query';

import { FilterDropdown } from '../../../components/uielements/filterDropDown';
import { getPrecinctOfAddress, getZoneList } from '../../../services/procedureService';

import {
  ApplyButton,
  ClearButton,
  CloseIcon,
  Content,
  FilterContainer,
  Footer,
  Header,
  Title,
  Wrapper,
} from './Clusters.styles';

import { ErrorText, PrimaryButton } from '../users/modals/UserPromoteModal.styles';

const ClusterFilter = ({ onApply, filters }) => {
  const filterRef = useRef(null);

  const [isOpen, setIsOpen] = useState(false);

  const [draftRegion, setDraftRegion] = useState('');
  const [draftPrecinct, setDraftPrecinct] = useState('');

  useEffect(() => {
    setDraftRegion(filters?.regionId || '');
    setDraftPrecinct(filters?.precinctId || '');
  }, [filters]);

  // zones
  const { data: zones = [], isLoading: zonesLoading } = useQuery({
    queryKey: ['zones-filter'],
    queryFn: getZoneList,
    staleTime: 5 * 60 * 1000,
  });

  // precincts
  const { data: precincts = [], isLoading: precinctLoading } = useQuery({
    queryKey: ['precinct-filter', draftRegion],
    queryFn: () =>
      getPrecinctOfAddress({
        regionId: draftRegion,
      }),
    enabled: !!draftRegion,
  });

  // useEffect(() => {
  //   setDraftPrecinct('');
  // }, [draftRegion]);

  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (filterRef.current && !filterRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleOutsideClick);

    return () => document.removeEventListener('mousedown', handleOutsideClick);
  }, []);

  const handleApply = () => {
    onApply({
      regionId: draftRegion,
      precinctId: draftPrecinct,
    });

    setIsOpen(false);
  };

  const handleReset = () => {
    setDraftRegion('');
    setDraftPrecinct('');

    onApply({
      regionId: '',
      precinctId: '',
    });

    setIsOpen(false);
  };

  const hasAppliedFilter = !!filters?.regionId || !!filters?.precinctId;

  return (
    <Wrapper ref={filterRef}>
      <PrimaryButton type="button" onClick={() => setIsOpen((prev) => !prev)}>
        Apply Filter
      </PrimaryButton>

      {isOpen && (
        <FilterContainer>
          <Header>
            <Title>Filter</Title>
            <CloseIcon onClick={() => setIsOpen(false)}>✕</CloseIcon>
          </Header>

          <Content>
            <FilterDropdown
              label="Select Zone"
              placeholder="All Zones"
              value={draftRegion}
              options={zones}
              loading={zonesLoading}
              onChange={(value) => {
                setDraftRegion(value);
              }}
            />

            <FilterDropdown
              label="Select Precinct"
              placeholder="All Precincts"
              value={draftPrecinct}
              options={precincts}
              loading={precinctLoading}
              disabled={!draftRegion}
              onChange={(value) => {
                setDraftPrecinct(value);
              }}
            />

            {!draftRegion && (
              <ErrorText
                style={{
                  color: '#5c5b5b',
                  fontSize: '12px',
                }}
              >
                Please select a region first
              </ErrorText>
            )}
          </Content>

          <Footer>
            {hasAppliedFilter && (
              <ClearButton type="button" onClick={handleReset}>
                Clear Filter
              </ClearButton>
            )}

            <ApplyButton type="button" onClick={handleApply}>
              Apply
            </ApplyButton>
          </Footer>
        </FilterContainer>
      )}
    </Wrapper>
  );
};

export default ClusterFilter;
